export const flatAndRateSection = {
    panelTitle: "Cost Worksheet",
    panelDescription: "Flat cost worksheet",
    tableHead: "MATERIAL & LABOR FLAT COST SECTION",
    editType: "edit",
    close:"Close",
    keyValues: {
        totalTM: 'totalTM',
        totalCost: 'totalCost'
    },
    tableColumnNames: {
        numberofItems: "# of Items",
        costperitem: "T&M Flat Material Cost Per Item",
        equalSimbol: "=",
        totalCost: "TotalCost"
    },
    placeHolderValues: {
        numberofItems: "0",
        costperitem: "0.00",
        totalCost: "0.00"
    }
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/utils/e-commerce/flat-rate.ts